export const COLOR_SOURCE_ID = 'colors';
export const PRODUCT_SOURCE_ID = 'products';
export const CONTENT_SOURCE_ID = 'content';
export const DOCUMENT_SOURCE_ID = 'documents';
export const QUERY_MIN_CHARS_NUMBER = 1;
export const STATE_SOURCE_TOTAL_HITS_NUMBER_PREFIX = 'total';
export const LINE_CLAMP_TITLE_AND_BODY_DISPLAYED = 2;
export const NO_LINE_CLAMP = 0;

export type SourceIdType =
  | typeof COLOR_SOURCE_ID
  | typeof PRODUCT_SOURCE_ID
  | typeof CONTENT_SOURCE_ID
  | typeof DOCUMENT_SOURCE_ID;
